import { Flex, Spinner } from "@chakra-ui/react";
import WithNavigationBarLayout from "src/components/WithNavigationBarLayout";

export default function LoadingView({ onClose }) {
  return (
    <WithNavigationBarLayout
      navigationBarProps={{
        headingKey: "activityLog.heading",
        onClose
      }}
    >
      <Flex pt="148px" justifyContent="center">
        <Spinner />
      </Flex>
    </WithNavigationBarLayout>
  );
}
